import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

import userReducer from '@redux/features/UserReducer';
import generalReducer from '@redux/features/GeneralReducer';

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['general', 'user'],
};

const middleware = (getDefaultMiddleware: any) => {
	if (process.env.APP_ENV === 'dev') {
		return getDefaultMiddleware().concat(logger);
	}
	return getDefaultMiddleware();
};

const rootReducer = combineReducers({
	general: generalReducer,
	user: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	devTools: true,
	middleware,
});
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
